import { action } from 'mobx';
import { LOADING, LOADED } from 'stores/BaseStore';
import BaseStore from 'stores/BaseStore';
import HttpClient from 'utils/httpclient';

class TagStore extends BaseStore {
  constructor() {
    super('cms/tags', 'cms/tag', { site_model: true });
  }

  @action all (params) {
    this.collection.readyState = LOADING;
    this.getCurrentSiteID();
    return (
      HttpClient.get(this.collectionURL, {params: params})
      .then(action(response => {
        const tags = response.data;
        this.collection.objects = tags;
        this.collection.count = tags.length;
        this.collection.readyState = LOADED;
        return response;
      })).catch(response => {
        this.collection.readyState = LOADED;
        throw response;
      })
    );
  }

  attachFilter = (query = {}, { labelKey = "name", valueKey = 'id', labelFormater = (name, id) => `[#${id}] ${name}` } = {}) => {
    return async () => {
      const store = await super.all(query)
      const options = store.data.map(({ [valueKey]: id, [labelKey]: name }) => { return { value: id, label: labelFormater(name, id) } })

      return { options };
    }
  }
}

export default new TagStore();